import { CrudModule } from "@/command/ccCrud";

export default function Sales() {
  return (
    <CrudModule
      title="Sales" subtitle="Pipeline and opportunities — feeds the Sales Pipeline KPI."
      module="sales" endpoint="/cc/sales/opportunities" entity="opportunity" summaryPath="/cc/sales/summary"
      columns={[["name", "Opportunity"], ["customer", "Customer"], ["deal_value", "Value", "money"], ["stage", "Stage", "badge"], ["owner", "Owner"], ["close_date", "Close"]]}
      fields={[["name", "Opportunity", "text"], ["customer", "Customer", "text"], ["deal_value", "Deal value (₹)", "number"],
        ["stage", "Stage", "select", ["Qualified", "Proposal", "Negotiation", "Won", "Lost"]], ["owner", "Owner", "text"], ["close_date", "Expected close", "date"]]}
      defaults={{ stage: "Qualified" }}
      kpis={(rows, s) => [
        { label: "Open Pipeline", value: s?.pipeline ?? 0, prefix: "₹" },
        { label: "Won", value: s?.won ?? 0, prefix: "₹" },
        { label: "Open Deals", value: s?.open_count ?? 0 },
        { label: "Total Deals", value: s?.total ?? rows.length },
      ]}
    />
  );
}
